"use client";

import { type ReactNode, useEffect, memo } from "react";

import { useLocalUiSetting } from "@/lib/local-ui/local-ui-settings-store";

export const SiteZoomProvider = memo(function SiteZoomProvider({ children }: { children: ReactNode; }) {
    const [zoom] = useLocalUiSetting("appearance.zoom");

    useEffect(() => {
        document.documentElement.style.zoom = `${zoom}`;
    }, [zoom]);

    return <>{children}</>;
});
